import { render, staticRenderFns } from "./CustomTextArea.vue?vue&type=template&id=92a978d8&xmlns%3Ab-form-group=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./CustomTextArea.vue?vue&type=script&lang=js&"
export * from "./CustomTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports